export default __webpack_public_path__ + "fa27d1b97cff4d910a7350f7d238358e.png";